import {
  i18n,
  LANGUAGE_ENGLISH,
  LANGUAGE_ESTONIAN,
} from '@atlas-frontend/i18n';
import { apiClient } from '../ApiClient';
import { createApiQueryHook } from '../queryClient/createApiQueryHook';
import { TranslationUrl } from './TranslationUrls';

const addBundles = (
  language: string,
  bundles?: Record<string, Record<string, unknown>>,
) => {
  if (!bundles) {
    return;
  }

  Object.entries(bundles).forEach(([bundle, resource]) => {
    if (resource) {
      i18n.addResourceBundle(language, bundle, resource, true, true);
    }
  });
};

const getTranslations = () =>
  apiClient.get(TranslationUrl.TRANSLATIONS).then((response) => {
    const { translations } = response.data;
    addBundles(LANGUAGE_ESTONIAN, translations[LANGUAGE_ESTONIAN]);
    addBundles(LANGUAGE_ENGLISH, translations[LANGUAGE_ENGLISH]);

    return response.data;
  });

const useTranslationOverridesInternal = createApiQueryHook(
  ['translations'],
  getTranslations,
  {
    staleTime: Infinity,
    gcTime: Infinity,
  },
);

export const useTranslationOverrides: typeof useTranslationOverridesInternal = (
  ...args
) => useTranslationOverridesInternal(...args);
